import { Form, Formik } from 'formik'
import React from 'react'
import Input from './common/Input'
import Button from './common/Button'
import { required } from '../utils/validators'
import useTrans from '../hooks/trans'

export default function DocsCategoryForm({ onSubmit, onCancel, loading, initialValues }) {
    const t = useTrans()

    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={{ name: '', ...initialValues }}>
            <Form>
                <Input
                    name="name"
                    label={t('name')}
                    disabled={loading}
                    validate={required}
                    placeholder={t('enterName')} />

                <div className="is-pulled-right">
                    <Button
                        onClick={onCancel}
                        icon="ion-md-close"
                        text={t('cancel')}
                        className="is-danger" />&nbsp;&nbsp;

                    <Button
                        loading={loading}
                        text={t('save')}
                        type="submit"
                        icon="ion-md-checkmark"
                        className="is-success" />
                </div>
            </Form>
        </Formik>
    )
}
